import React from 'react'
import { GenericTable } from '../_EOS/Table'
import { Box, Button } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { headersConfig } from './config'
import { ReturnWorkOrderResponse } from './types'
import { styles } from './styles'
import { BlogStep } from '../../enums/eBlogStep'

interface MultipleReturnsProps {
  data: ReturnWorkOrderResponse[]
  setSelectedWorkOrder: (workOrderId: number) => void
  handleStep: (step: number) => void
}

export const MultipleReturns: React.FC<MultipleReturnsProps> = ({
  data,
  setSelectedWorkOrder,
  handleStep
}) => {
  const [selectedElement, setSelectedElement] = React.useState<number[]>([])

  const handleCheckChange = (id: number, _checked: boolean) => {
    setSelectedElement([id])
  }

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <GenericTable<ReturnWorkOrderResponse>
          headersConfig={headersConfig}
          data={data}
          showCheckboxes
          onCheckChange={handleCheckChange}
          checkedElements={selectedElement}
          IDKey='workOrderId'
          dense={true}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Box sx={styles.centerButton}>
          <Button
            onClick={() => handleStep(BlogStep.Buscar)}
            variant='contained'
            color='primary'
          >
            Volver
          </Button>
        </Box>
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Box sx={styles.centerButton}>
          <Button
            disabled={selectedElement.length === 0}
            onClick={() => setSelectedWorkOrder(selectedElement[0])}
            color='primary'
            variant='contained'
          >
            Seleccionar
          </Button>
        </Box>
      </Grid>
    </Grid>
  )
}
